const doc = [({"da":({"js":({"admin":({"invoice_lines":({"create_card":({"create_invoice_line":"Opret fakturalinje", "invoice_line_was_created":"Fakturalinjen blev oprettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;